import { AreaUnit } from '@search/filter-enums/enums/AreaUnit';
import { AreaUnitEnum } from '../__generated__/SearchOffersQuery.graphql';

export function areaUnitCompat(unit?: AreaUnitEnum | null): AreaUnit {
    switch (unit) {
        case 'ARE': return AreaUnit.ARE;
        case 'HECTARE': return AreaUnit.HECTARE;
        case 'METER': return AreaUnit.METER;
        default: return AreaUnit.UNKNOWN;
    }
}

export function areaCompat(
    area: {
        readonly value?: number | null;
        readonly unit?: AreaUnitEnum | null;
    } | null | undefined
): {
    value: number;
    unit: AreaUnit;
} {
    return {
        value: area?.value ?? 0,
        unit: areaUnitCompat(area?.unit)
    };
}
